import React, { useState, useCallback, useMemo } from 'react'
import { IconButton, Tooltip } from 'shared/ui'
import { doOpenRawEmailPage } from 'actions/pages'
import { useDrawer } from 'ducks/drawers/hooks'
import { DRAWER_TYPE_RULES_UPDATE } from 'ducks/drawers/types'

import { getByline } from './util'

const Header = ({
  action,
  currentUserId,
  isNote,
  isFirstMessage,
  isForward,
  hasAttachments,
  isFromMerge,
  hasRawEmail,
  readReceipt,
  onCopyLinkClick,
  onPrintClick,
}) => {
  const [disableTooltip, setDisableTooltip] = useState(true)

  const onMouseEnter = useCallback(e => {
    // only show tooltip if container text is overflowing
    setDisableTooltip(
      e.currentTarget.clientWidth >= e.currentTarget.scrollWidth
    )
  }, [])

  const onRawEmailClickStopPropagation = useCallback(e => {
    // prevent the href click from collapsing the changeset
    e.stopPropagation()
  }, [])

  const rawEmailTo = useMemo(() => doOpenRawEmailPage(action.change.id), [
    action.change.id,
  ])

  const { openDrawer: openCreateEditDrawer } = useDrawer(
    DRAWER_TYPE_RULES_UPDATE
  )

  const openRuleEditDrawer = useCallback(
    (event, id) => {
      event.stopPropagation()
      openCreateEditDrawer(id)
    },
    [openCreateEditDrawer]
  )

  const datetime = action.datetime
  const byLine = getByline({
    action,
    currentUserId,
    isNote,
    isFirstMessage,
    isForward,
  })

  return (
    <div className="header">
      <Tooltip
        className="byline-container"
        disabled={disableTooltip}
        tooltip={byLine}
      >
        {getByline(
          {
            action,
            currentUserId,
            isNote,
            isFirstMessage,
            isForward,
          },
          {
            onMouseEnter,
            openRuleEditDrawer,
          }
        )}
      </Tooltip>
      <div className="right-side">
        <div className="meta">
          {readReceipt && <div className="read-receipt">SEEN</div>}
          <div className="icons">
            {hasAttachments && <div className="Icon Icon-attachment" />}
            {isFromMerge && <div className="Icon Icon-merge" />}
          </div>
          <div className="datetime">{datetime}</div>
        </div>
        <div className="actions hidden-in-print">
          <IconButton
            name="print"
            svg
            onClick={onPrintClick}
            size="small"
            tooltip="Print"
            iconSize={16}
          />
          <IconButton
            name="link"
            svg
            onClick={onCopyLinkClick}
            size="small"
            tooltip={
              <span>
                Copy Link<br />to Message
              </span>
            }
            iconSize={18}
          />
          {hasRawEmail && (
            <IconButton
              name="externalLink"
              to={rawEmailTo}
              target="_blank"
              svg
              onClick={onRawEmailClickStopPropagation}
              size="small"
              tooltip={
                <span>
                  View<br />Raw Email
                </span>
              }
              iconSize={16}
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default Header
